import { AcknowledgeModal } from '@statsbomb/kitbag-components';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useFirstTimeDismissal } from '@/hooks/useFirstTimeDismissal';
import { OnboardingItemKey } from '@/types/userConfigs';

type FirstTimeModalProps = {
  modalType: OnboardingItemKey;
  id: string;
  title: string;
  confirmLabel: string;
  onConfirmNavigate?: () => void;
  testId?: string;
  children: ReactNode;
};

export const FirstTimeModal = ({
  modalType,
  id,
  title,
  confirmLabel,
  onConfirmNavigate,
  testId,
  children,
}: FirstTimeModalProps) => {
  const { isOpen, dismiss } = useFirstTimeDismissal(modalType);
  const { t } = useTranslation('general');
  if (!isOpen) return null;

  const handleConfirm = () => {
    dismiss();
    onConfirmNavigate?.();
  };

  return (
    <AcknowledgeModal
      id={id}
      title={title}
      isOpen
      onConfirm={handleConfirm}
      confirmLabel={confirmLabel}
      testId={testId ?? id}
      closeLabel={t('close')}
      onClose={dismiss}
    >
      {children}
    </AcknowledgeModal>
  );
};
